import React, { Fragment, useState } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Paper, Typography } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { actualizaCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { useDispatch, useSelector } from 'react-redux'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../../redux/AppDucks'
import moment from 'moment'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent';


function DatosGeneralesComponent(props) {

    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)

    let [editar, setEditar] = React.useState(false)
    let cliente = props?.cliente
    const [numerosocio, setNumeroSocio] = React.useState(props?.cliente?.numerosocio);
    const [nombrerazonsocial, setNombreRazonSocial] = React.useState(props?.cliente?.nombrerazonsocial?.toUpperCase())
    const [rfc, setRfc] = React.useState(cliente?.rfc?.toUpperCase())
    const [telefono, setTelefono] = React.useState(cliente?.telefono)
    const [correoelectronico, setCorreoElectronico] = React.useState(cliente?.correoelectronico)
    const [nombrerepresentantelegal, setNombreRepresentanteLegal] = React.useState(cliente?.nombrerepresentantelegal?.toUpperCase())
    const [telefonorepresentante, setTelefonoRepresentante] = React.useState(cliente?.telefonorepresentante)
    const [correoelectronicorepresentante, setCorreoElectronicoRepresentante] = React.useState(props?.cliente?.correoelectronicorepresentante)
    const [idtipocliente, setIdTipoCliente] = React.useState(cliente?.tipocliente?.idtipocliente)
    let [representante, setRepresentante] = React.useState(nombrerepresentantelegal == '' ? true : false)

    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => { setOpenModal(true) }
    const handleCloseModal = () => { setOpenModal(false) }

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(cliente?.clientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(cliente?.clientehistorial)
        setOpenModalHistorial(true)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 450,
        height: 250,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '5px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            },
        }
    });

    const obtenerCadenaActividades = (actividadcliente) => {
        const arregloCadena = actividadcliente?.map(item => item?.tipoactividad?.actividad || '');
        let combinacionCadena = '';
        if (arregloCadena?.length == 1) {
            combinacionCadena = arregloCadena[0];
        } else if (arregloCadena?.length > 1) {
            combinacionCadena = arregloCadena.slice(0, -1).join(', ') + ' y ' + arregloCadena.slice(-1);
        }
        return combinacionCadena;
    };

    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h4" sx={{ mt: 0, fontFamily: 'Montserrat', fontWeight: 'bold', textAlign: 'center' }}>
                            ADVERTENCIA
                        </Typography>
                        <Typography id="modal-modal-description" variant="p" sx={{ fontFamily: 'Montserrat', textAlign: 'center' }}>
                            <div style={{ marginTop: '4%' }}>¿Está seguro que desea actualizar la información del cliente?</div>
                        </Typography>
                        <ThemeProvider theme={theme}>
                            <div className='row mt-3'>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
                                </div>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnContinuar() }}>Continuar</Button>
                                </div>
                            </div>
                        </ThemeProvider>
                    </Box>
                </Modal>
            </div>
        )
    }

    const btnContinuar = async () => {
        const fechaHoy = moment().format('YYYY-MM-DD')

        await dispatch(actualizarLoadingApp_true())
        let fechainscripcion = new Date(fechaHoy).toISOString()
        let dataValida = {
            datacambio: {
                numerosocio: numerosocio, nombrerazonsocial: nombrerazonsocial, rfc: rfc, telefono: telefono,
                correoelectronico: correoelectronico, nombrerepresentantelegal: nombrerepresentantelegal,
                telefonorepresentante: telefonorepresentante, correoelectronicorepresentante: correoelectronicorepresentante,
                idcliente: props?.data?.idcliente, idtipocliente: idtipocliente
            }, idcliente: props?.data?.idcliente, usuariocambio: dataUser?.[0]?.usuario, fechacambio: fechainscripcion
        }
        await dispatch(actualizaCliente(dataValida))
        setOpenModal(false)
        props?.setIsEdicionCliente(true)
        setEditar(false)
        await dispatch(actualizarLoadingApp_false())
    }

    return (
        <Fragment>
            <div className='row' style={{ marginLeft: 24, marginRight: 24 }}>
                {!editar &&
                    <div className='row' style={{ margin: 0, padding: 0 }}>
                        <div className="col-12 col-md-12 mt-0 mb-0 p-0 pe-4 text-end" >
                            <Tooltip title="Ver historial de cambios">
                                <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                    <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Número de socio: <br /> </b> {numerosocio} </label> </div>
                        <div className="col-md-8 mt-3 ps-5 text-start"><label><b>Razón social: <br /> </b> {nombrerazonsocial} </label> </div>
                        <div className="col-md-3 mt-3 ps-5 text-start"><label><b>RFC: <br /> </b> {rfc} </label> </div>
                        <div className="col-md-3 mt-3 ps-5 text-start"><label><b>Tipo Cliente: <br /> </b> {cliente?.tipocliente?.idtipocliente == 1 ? 'No Asociado' : cliente?.tipocliente?.idtipocliente == 2 ? 'Asociado' : cliente?.tipocliente?.idtipocliente == 3 ? 'Inscrito' : ''} </label> </div>
                        <div className="col-md-3 mt-3 ps-5 text-start"><label><b>Teléfono: <br /> </b> {telefono} </label> </div>
                        <div className="col-md-3 mt-3 ps-5 text-start"><label><b>Correo electrónico: <br /> </b> {correoelectronico} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Nombre representante legal: <br /> </b> {nombrerepresentantelegal == '' ? '---' : nombrerepresentantelegal} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Teléfono representante: <br /> </b> {telefonorepresentante == '' ? '---' : telefonorepresentante} </label> </div>
                        <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Correo representante: <br /> </b> {correoelectronicorepresentante == '' ? '---' : correoelectronicorepresentante} </label> </div>
                        <div className="col-md-12 mt-3 ps-5 text-start"><label><b>Cadena productiva: <br /> </b> {obtenerCadenaActividades(props?.data.actividadcliente)?.toUpperCase()} </label> </div>
                    </div>
                }
                {editar &&
                    <div className='row' style={{ margin: 0, padding: 0 }}>
                        <div className='col-md-2'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control `} id="floatingInput" value={numerosocio} onChange={e => setNumeroSocio(e.target.value)} disabled={!editar} />
                                <label htmlFor='floatingInput'>Número de socio</label>
                            </div>
                        </div>
                        <div className='col-md-7'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control `} id="floatingInput" value={nombrerazonsocial} onChange={e => setNombreRazonSocial(e.target.value?.toUpperCase())} disabled={!editar} />
                                <label htmlFor='floatingInput'>Razón social</label>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-floating mb-2">
                                <select className={`form-control`} id="floatingInput" value={idtipocliente != undefined ? idtipocliente : cliente?.tipocliente?.idtipocliente} onChange={e => setIdTipoCliente(parseInt(e.target.value))} disabled={!editar}>
                                    <option value=''>Seleccione una opción</option>
                                    <option value={1}>Cliente No Asociado</option>
                                    <option value={2}>Cliente Asociado</option>
                                </select>
                                <label htmlFor='floatingInput'>Tipo Cliente</label>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control `} id="floatingInput" value={rfc} onChange={e => setRfc(e.target.value?.toUpperCase())} disabled={!editar} />
                                <label htmlFor='floatingInput'>RFC</label>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control `} id="floatingInput" value={telefono} onChange={e => setTelefono(e.target.value)} disabled={!editar} />
                                <label htmlFor='floatingInput'>Teléfono</label>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="form-floating mb-2">
                                <input type="text" className={`form-control `} id="floatingInput" value={correoelectronico} onChange={e => setCorreoElectronico(e.target.value?.toUpperCase())} disabled={!editar} />
                                <label htmlFor='floatingInput'>Correo electrónico</label>
                            </div>
                        </div>
                        {representante == false &&
                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <input type="text" className={`form-control `} id="floatingInput" value={nombrerepresentantelegal} onChange={e => setNombreRepresentanteLegal(e.target.value?.toUpperCase())} disabled={!editar} />
                                    <label htmlFor='floatingInput'>Representante legal</label>
                                </div>
                            </div>
                        }
                        {representante == false &&
                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <input type="text" className={`form-control `} id="floatingInput" value={telefonorepresentante} onChange={e => setTelefonoRepresentante(e.target.value)} disabled={!editar} />
                                    <label htmlFor='floatingInput'>Teléfono representante</label>
                                </div>
                            </div>
                        }
                        {representante == false &&
                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <input type="text" className={`form-control `} id="floatingInput" value={correoelectronicorepresentante} onChange={e => setCorreoElectronicoRepresentante(e.target.value)}
                                        disabled={!editar} />
                                    <label htmlFor='floatingInput'>Correo representante</label>
                                </div>
                            </div>
                        }
                    </div>
                }
                {!editar && dataUser?.[0]?.idrol == 1 &&
                    <ThemeProvider theme={theme}>
                        <div className='col-md-12 mt-4 mb-5 justify-content-center'>
                            <Button variant="contained" color="primary" style={{ width: '50%' }} onClick={() => setEditar(true)}>Editar información general</Button>
                        </div>
                    </ThemeProvider>
                }
                {editar &&
                    <ThemeProvider theme={theme}>
                        <div className='row mt-4 mb-5'>
                            <div className='col-6 col-md-6 justify-content-center'>
                                <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => setEditar(false)}>Cancelar</Button>
                            </div>
                            <div className='col-6 col-md-6 justify-content-center'>
                                <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => handleOpenModal()}>Guardar cambios</Button>
                            </div>
                        </div>
                    </ThemeProvider>
                }
            </div>
            {modalComponent()}
            {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Datos generales"} />}
        </Fragment>
    )
}

export default DatosGeneralesComponent